import { Download } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useExportDataSource } from '~/api/data-sources';
import { ExportDownloadDialog } from '../../components';

interface ExportButtonProps {
  dataSourceId: number;
}

export const ExportButton = ({ dataSourceId }: ExportButtonProps) => {
  const { t } = useTranslation();
  const [exportDataSource, { loading }] = useExportDataSource();
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  return (
    <>
      <LoadingButton
        color="primary"
        loading={loading}
        onClick={async () => {
          const result = await exportDataSource({ variables: { input: { id: dataSourceId } } });
          setDownloadUrl(() => result.data?.exportDataSource?.url ?? null);
        }}
        startIcon={<Download />}
        variant="contained"
      >
        {t('common.buttons.export')}
      </LoadingButton>
      <ExportDownloadDialog close={() => setDownloadUrl(() => null)} downloadUrl={downloadUrl} />
    </>
  );
};
